import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cn } from '../../lib/cn';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  hasError?: boolean;
}

/** Multi-line input for notes and the rule-definition JSON editor; styled to match `Input`. */
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(({ className, hasError = false, rows = 6, ...props }, ref) => (
  <textarea
    ref={ref}
    rows={rows}
    aria-invalid={hasError || undefined}
    className={cn(
      'w-full rounded-md border border-border bg-background px-3 py-2 text-sm text-foreground',
      'placeholder:text-muted-foreground',
      'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:ring-offset-background',
      'disabled:cursor-not-allowed disabled:opacity-50',
      hasError && 'border-destructive focus-visible:ring-destructive',
      className,
    )}
    {...props}
  />
));

Textarea.displayName = 'Textarea';
